import React from 'react';
import classNames from 'classnames';
import styles from './mainImage.scss';
import '../../../styles/customCarouselStyles.scss';
import { inject, observer } from 'mobx-react';
import { IMixedMediaStore } from '../../../types';
import { EyeCatcher } from '../eyeCatcher/eyeCatcher';
import Zoom from '../../icons/zoom';
import NormalImage from './normalImage/normalImage';
import MainImageCarousel from './mainImageCarousel/mainImageCarousel';
import TabNavigationHelper from '../../../helper/tabNavigationHelper';
import { lockBodyScroll } from '../../../hooks/useBodyScrollLock';

export const MainImage = inject('mixedMediaStore')(
    observer(({ mixedMediaStore }: IMixedMediaStore) => {

        const tabNavigation = TabNavigationHelper.instance;

        function openMediaOverlay(): void {
            const lockEventSource = 'PDP.MainImage';
            mixedMediaStore?.updateMediaOverlayVisibility(true);
            lockBodyScroll(lockEventSource)
            mixedMediaStore?.mainStore.hideEsAppButton();
        }

        return (
            <div className={styles.main_image_container}>
                <div
                    className={classNames(styles.zoom_icon, { [styles.zoom_only]: !mixedMediaStore?.has3DView })}
                    onClick={openMediaOverlay}
                    data-testid={'pdp-zoom-button'}
                    ref={(el)=>tabNavigation.setFocusAtt(el)}
                >
                    <Zoom />
                </div>
                <EyeCatcher />
                {mixedMediaStore?.shouldRenderMainImageCarousel ? <MainImageCarousel /> : <NormalImage />}
            </div>
        );
    })
);

